import { render, staticRenderFns } from "./Hives.vue?vue&type=template&id=c6bcc35c&lang=pug&"
import script from "./Hives.vue?vue&type=script&lang=js&"
export * from "./Hives.vue?vue&type=script&lang=js&"
import style0 from "./Hives.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports